import React from 'react';
import { LayoutDashboard, Users, Network, ShieldAlert, BarChart3, Settings, LogOut, X, Briefcase, BookOpen, TrendingUp, PieChart, DollarSign, Zap } from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab, userRole, isOpen, setIsOpen }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Overview', icon: LayoutDashboard },
    { id: 'clients', label: 'Clients', icon: Users },
    { id: 'funded-accounts', label: 'Funded Accounts', icon: Zap },
    { id: 'partners', label: 'IB Partners', icon: Network },
    { id: 'compliance', label: 'Compliance', icon: ShieldAlert },
    { id: 'finance', label: 'Finance', icon: PieChart }, 
    { id: 'team-hub', label: 'Team Hub', icon: Briefcase }, 
    { id: 'signals', label: 'Trade Signals', icon: TrendingUp }, 
    { id: 'academy', label: 'Academy CMS', icon: BookOpen },
    { id: 'marketing', label: 'Marketing', icon: BarChart3 },
  ];

  // Strictly lock the Admin tabs to the 'Admin' role only
  if (userRole === 'Admin') {
    menuItems.push({ id: 'investment-admin', label: 'Investment Hub', icon: DollarSign });
    menuItems.push({ id: 'admin', label: 'Admin Settings', icon: Settings });
  }

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/60 z-40 md:hidden backdrop-blur-sm" onClick={() => setIsOpen(false)} />}
      <div className={`fixed top-0 left-0 h-full w-72 bg-slate-900 border-r border-slate-800 z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 shadow-2xl`}>
        <div className="p-6 md:p-8 border-b border-slate-800/50 flex justify-between items-center">
          <div className="flex items-center space-x-2">
             <img 
               src="/nommia-logo.png" 
               alt="Nommia CRM" 
               className="h-14 w-auto object-contain" 
             />
          </div>
          <button onClick={() => setIsOpen(false)} className="md:hidden text-slate-400 hover:text-white"><X size={24} /></button>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {menuItems.map((item) => (
            <button key={item.id} onClick={() => { setActiveTab(item.id); setIsOpen(false); }} className={`w-full flex items-center justify-between px-4 py-3.5 rounded-lg transition-all duration-200 group ${activeTab === item.id ? 'bg-amber-500/10 text-amber-400 border border-amber-500/20 shadow-lg shadow-amber-900/20' : 'text-slate-400 hover:bg-slate-800 hover:text-white border border-transparent'}`}>
              <div className="flex items-center space-x-3">
                  <item.icon size={18} className={activeTab === item.id ? 'text-amber-400' : 'text-slate-500 group-hover:text-white'} />
                  <span className="font-medium text-sm">{item.label}</span>
              </div>
              {activeTab === item.id && <div className="w-1.5 h-1.5 rounded-full bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.8)]"></div>}
            </button>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800">
          <button className="flex items-center space-x-3 px-4 py-3 text-slate-400 hover:text-red-400 transition-colors w-full rounded-lg hover:bg-red-900/10"><LogOut size={18} /><span className="text-sm font-medium">Sign Out</span></button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;